export default __webpack_public_path__ + "static/media/cup@3x.f06ac4a1.webp";